export default __webpack_public_path__ + "static/media/azure.16afec27c7001da4be828a235f2ed2ce.svg";